import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import { asset } from 'Services/BaseHelpers';

import FrameTitle from './FrameTitle';

const GameScreen = ({ image, handleNonTargetClick, crossPosition }) => {
    return (
        <div
            onClick={handleNonTargetClick}
        >
            {crossPosition &&
                <div
                    className="absolute"
                    style={{
                        top: crossPosition[1] + 'px',
                        left: crossPosition[0] + 'px'
                    }}
                >
                    <button
                        className={`
                            text-md lg:text-2xl w-8 h-8 lg:h-12 lg:w-12 z-10 relative
                            rounded-full flex items-center justify-center
                            target bg-[#656D71] text-white
                        `}
                        style={{
                            boxShadow: '-6px 6px 8px rgba(0, 0, 0, 0.5)'
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            }

            <img
                src={asset(`images/hazard/${image}`)}
            />

            <FrameTitle game={true}>
                CAM 1
            </FrameTitle>
        </div>
    );
};

export default GameScreen;
